import { put, call, select } from 'redux-saga/effects';
import {
  GESTION_OPERATIVA_GET_COTIZACION_BEGIN,
  GESTION_OPERATIVA_GET_COTIZACION_SUCCESS,
  GESTION_OPERATIVA_GET_COTIZACION_FAILURE,
  GESTION_OPERATIVA_ADD_USADO_A_ENTREGAR,
  GESTION_OPERATIVA_GET_PERITAJE_SUCCESS
} from '../constants'

import { PERITAJE_STATUS, PERITAJE_BUSINESS_UNITS } from '../../../../common/BFF/BFF_peritador/constants'
import { BFFAgent } from '../../../../common/BFFAgent'

export default function* getCotizacionSaga({data: {params}}) {
  try {
      yield put({
        type: GESTION_OPERATIVA_GET_COTIZACION_BEGIN,
      })

      const businessUnits = yield call(BFFAgent.Peritador.getBusinessUnits)
      const originChannels = yield select(state => state.peritador.originChannels)
      const cotizador = yield call(BFFAgent.Cotizador.getCotizacion,params);
      let dataVehicle = cotizador?.vehicle
      let sale = yield select( state => state.gestionOperativa.sale)
      let takingCars = yield select( state => state.gestionOperativa.sale.Taking_cars)
      let dataQuote = cotizador?.quote
      let gestionOperativa = yield select( state => state.gestionOperativa)
      let takingCar = null;
      let SaleBusinessUnit = sale.catalog_nuevo ? PERITAJE_BUSINESS_UNITS.NUEVOS : PERITAJE_BUSINESS_UNITS.USADOS
      const currentBusinessUnit = businessUnits?.find(item => item.Name === SaleBusinessUnit)
      const origin_channel_id = originChannels?.find(item => item.name === String(SaleBusinessUnit).toLowerCase())?.id;
      const estimatedSalePrices = dataQuote?.prices.find(item => item.type === 'estimated')
      if(cotizador.error?.name === 'Vehiculo no segmentado'){
        throw new Error('El vehículo no se encuentra segmentado')
      } else {
        takingCar = {
          use_take_improvement: false,
          take_improvement_amount: dataVehicle.quote?.discounts[0].amount ? dataVehicle.quote?.discounts[0].amount : 0 ,
          taking_auth_id: "",
          saleId: gestionOperativa.sale?.id,
          original_price: estimatedSalePrices.amount,
          final_take_price: estimatedSalePrices.amount,
          year: dataVehicle.year,
          brand: dataVehicle.brandName,
          model: dataVehicle.modelName,
          version: dataVehicle.versionName,
          version_id: dataVehicle.version,
          license_plate: cotizador.licencePlate,
          mileage: cotizador.kms,
          updatedAt: cotizador.lastUpdate,
          quotation_id: cotizador.id,
          business_unit: currentBusinessUnit?.id,
          origin_channel_id
        }
      }

      const peritajeFinalizado =  yield call(BFFAgent.Peritador.getPeritaje ,cotizador.licencePlate, true, true, PERITAJE_STATUS.PERITAJE_FINALIZADO);

      if(peritajeFinalizado.peritaje){
        takingCar = {
          appraisal: peritajeFinalizado.peritajeQuote.appraisal,
          final_take_price: peritajeFinalizado.peritajeQuote.appraisal,
          //precio: peritajeFinalizado.peritajeQuote.final_take_price,
          original_price: peritajeFinalizado.peritajeQuote.appraisal,
          appraisal_approved: peritajeFinalizado.peritajeQuote.appraisal_approved,
          use_take_improvement: false, // -->agregar con feature mejora precio
          take_improvement_amount: 0, // -->agregar con feature mejora precio
          taking_auth_id:'',
          quotation_id: peritajeFinalizado.peritajeQuote.requestsId,
          year: peritajeFinalizado.peritajeQuote.verification?.original_vehicle?.year?.value || peritajeFinalizado.peritajeQuote.verification?.vehicle.year.label,
          brand: peritajeFinalizado.peritajeQuote.verification.vehicle.brand.label,
          model: peritajeFinalizado.peritajeQuote.verification?.vehicle.model.label,
          version: peritajeFinalizado.peritajeQuote.verification?.original_vehicle?.version?.label || peritajeFinalizado.peritajeQuote.verification?.vehicle.version.label,
          version_id: peritajeFinalizado.peritajeQuote.verification?.original_vehicle?.version?.value || peritajeFinalizado.peritajeQuote.verification?.vehicle.version.value,
          license_plate: peritajeFinalizado.peritajeQuote.verification?.original_licencePlate || peritajeFinalizado.peritajeQuote.verification?.licencePlate,
          mileage: peritajeFinalizado.peritajeQuote.verification?.original_kilometraje || peritajeFinalizado.peritajeQuote.verification?.kilometraje,
          assessed: Number(peritajeFinalizado.peritajeQuote.verification.statusId),
          assessmentDate: peritajeFinalizado.peritaje?.modificationDate,
          requestsId: peritajeFinalizado.peritaje.id
        }

          yield put({
            type: GESTION_OPERATIVA_GET_PERITAJE_SUCCESS,
            data: { peritaje: peritajeFinalizado.peritaje, peritajeQuoteVerification: peritajeFinalizado.peritajeQuote.verification },
          })

      } else {
        const peritajeNoFinalizado =  yield call(BFFAgent.Peritador.getPeritaje ,cotizador.licencePlate, true, false, PERITAJE_STATUS.PERITAJE_PENDIENTE); 
        if(peritajeNoFinalizado.peritaje){
          takingCar = {
            final_take_price: estimatedSalePrices.amount,
            original_price: estimatedSalePrices.amount,
            use_take_improvement: false, // -->agregar con feature mejora precio
            take_improvement_amount: dataVehicle.quote?.discounts[0].amount ? dataVehicle.quote?.discounts[0].amount : 0 ,
            quotation_id: cotizador.id,
            year: dataVehicle.year,
            brand: dataVehicle.brandName,
            model: dataVehicle.modelName,
            version: dataVehicle.versionName,
            version_id: dataVehicle.version,
            license_plate: cotizador.licencePlate,
            mileage: cotizador.kms,
            assessed: Number(peritajeNoFinalizado.peritaje.statusId),
            requestsId: peritajeNoFinalizado.peritaje.id,
            createdAt: sale.createdAt,
            saleId: sale.id,
            taking_auth_id: ''
          }
        }
      }

        yield put({
              type: GESTION_OPERATIVA_ADD_USADO_A_ENTREGAR,
              data: {
                takingCar,
                isModified: true
              }
            })

        yield put({
          type: GESTION_OPERATIVA_GET_COTIZACION_SUCCESS,
          data: { sale, takingCars },
        })

      } catch (err) {

      yield put({
        type: GESTION_OPERATIVA_GET_COTIZACION_FAILURE,
        data: { error: err?.message, takingCarFormData: params },
      })
    }
    }
